import React from 'react'
import TopContext from './Common/TopContext'
import TopContextData from './Common/TopContextData'
import DbList from '../Common/Services/DbList';
import DbListData from '../Common/Services/DbListData';
import { Helmet } from 'react-helmet';
import icon from '../../Assets/images/icons/logo.png'

const AssistedHeching = () => {
    const {greenHeading, head, video, pOne} = TopContextData.AssistedHeching;
    const {dlHeading, Dldata} = DbListData.AssistedHeching;

  return (
    <>
    <Helmet>
      <title>Assisted Zona Hatching: Boosting IVF Success for Couples</title>
      <meta name='description' content='Best world technique, Assisted Zona Hatching (AZH), improves embryo implantation by thinning the outer shell in IVF treatments.' />
      <meta name='keywords' content='' />
      <link rel="canonical" href="https://acmefertility.com/Programme/AssistedHeching" />
      <meta name="robots" content="Index, follow " />
      <link rel="icon" href={icon} />
    </Helmet>
    <TopContext greenHeading={greenHeading} head={head} video={video} pOne={pOne} />
    <DbList dlHeading={dlHeading} Dldata={Dldata} />
    
    </>
  )
}

export default AssistedHeching